import { render, staticRenderFns } from "./WorkerBasicInfo.vue?vue&type=template&id=7a9f2c1b&"
import script from "./WorkerBasicInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports